<template>
  <div class="diagnosis_lightbox">
    <div class="dLinghtbox_show">
      <section>
        <p>{{ title }}</p>
        <img
          class="img-responsive"
          :src="imgOfPartNo"
          :alt="title"
        />
      </section>
      <ul class="dia_timeBar timelineBar list-unstyled">
        <step
          :description="description.desc1"
          step="one"
          :styleClass="{
            styleMain: {step: true, success: true, hidden: isGreen}
          }">
        </step>
        <step
          :hmiDisplayConsole="hmiDisplayConsole"
          :description="description.desc2"
          :status="description.status"
          :displayConsoleText="description.displayConsoleText"
          :strSlice="strSlice(description.desc2)"
          step="two"
          :second="second"
          :time="time"
          :styleClass="{
            styleMain: {step: true, 'step-bar-none-finish': isHide, error: isError, active: isActive, success: isSuccess},
            styleStatus: {error: isError, success: isSuccess}
          }">
        </step>
        <step
          :description="description.desc3"
          step="three"
          :styleClass="{
            styleMain: {step: true, 'hidden': isHide}
          }">
        </step>
      </ul>
    </div>
    <div class="dLinghtbox_control">
      <Operator
        :btnHmi="btnHmi"
        :btnText="{up: keyName.up, down: keyName.down, power: keyName.power}"
        :isHidePower="isHidePower"
        @specialHmi="funcHandleSpecialHmi"
        @keyUpEvent="funcHandleUp"
        @keyDownEvent="funcHandleDown('cancel')"
        @keyPowerEvent="funcHandlePower(btnStep)"/>
    </div>
  </div>
</template>
<script>
import Operator from './Operator';
import Step from './Step';
import { mapGetters } from 'vuex';
import { allowPartNo, funcOriginalPartNo } from '@/utils/allowPartNo';

export default {
  name: 'DiagnosisHmiDisplayConsoleStep',
  props: [
    'modalOpen',
    'title',
    'btn',
    'bikeVal',
    'content',
    'seconds',
    'bikeErrorCode',
    'btnHmi'
  ],
  components: {
    Operator,
    Step
  },
  data () {
    return {
      hmiDisplayConsole: false,
      description: {
        desc1: '',
        desc2: this.content.step1,
        desc3: this.content.step2,
        status: '',
        displayConsoleText: {
          panel: '',
          panelResult: '',
          up: '',
          upResult: '',
          power: '',
          powerResult: ''
        }
      },
      btnStep: this.btn,
      btnDisabled: false,
      isGreen: true,
      isHide: false,
      isActive: true,
      isError: false,
      isSuccess: false,
      isHidePower: false,
      btnName: [
        'Start', 'Cancel', 'Next', '', '', '', 'Finish'
      ],
      btnNext: {
        step1: 'start',
        step2: 'LCDBtn',
        step3: 'next',
        step4: 'upBtn',
        step5: 'downBtn',
        step6: 'powerBtn',
        step7: 'finish'
      },
      count: 0,
      second: 10,
      interval: null,
      time: false,
      keyName: {
        up: '',
        down: 'Cancel',
        power: 'Start',
        cancel: 'cancel'
      },
      diagnosisName: 'diagnosisHmiDisplayConsole',
      keyText: ''
    };
  },
  mounted () {
    this.$bus.$on('powerClick', (text) => {
      switch (text) {
        case 'Up':
          this.funcHandleUp(text);
          break;
        case 'Down':
          this.funcHandleDown(text);
          break;
        case 'start':
          this.funcHandlePower(this.btnStep);
          break;
        case 'cancel':
          this.funcHandleDown(text);
          break;
        case 'cancelPower':
          this.funcHandlePower(text);
          break;
        case 'finish':
          this.funcHandlePower(this.btnStep);
          break;
      }
      if (!text) {
        this.funcHandlePower(this.btnStep);
      }
    });
  },
  beforeDestroy () {
    this.$bus.$off('powerClick');
  },
  watch: {
    content: {
      handler: function () {
        this.funcStepDefault();
      },
      immediate: true
    },
    keyText () {
      this.funcStepOne();
    },
    seconds (val) {
      this.second = 10 - val;
    },
    count (val) {
      // 這裡有問題
      if (val === 2) {
        this.second = 10;
      } else if (val === 3) {
        // up
        this.second = 10;
        this.$emit('keyPowerEvent', { name: 'Next', action: this.btnNext[this.step[val]] });
      } else if (val === 4) {
        // down
        this.second = 10;
        this.$emit('keyPowerEvent', { name: 'Next', action: this.btnNext[this.step[val]] });
        this.funcStepThree();
      } else if (val === 5) {
        // power
        this.second = 10;
        this.$emit('keyPowerEvent', { name: 'Next', action: this.btnNext[this.step[val]] });
        this.funcStepFour();
      } else if (val === 6) {
        // finish
        this.$emit('keyPowerEvent', { name: 'Next', action: this.btnNext[this.step[val]] });
        this.funcStepFive();
      }
    },
    modalOpen (val) {
      // 如果關閉modal
      this.funcStepDefault();
      if (!val) this.btnStep = 'Start';
    },
    bikeVal (val) {
      switch (this.btnNext[this.step[this.count]]) {
        case 'upBtn':
          this.funcStepTwo();
          break;
        case 'downBtn':
          this.funcStepThree();
          break;
        case 'powerBtn':
          this.funcStepFour();
          break;
      }
    }
  },
  computed: {
    ...mapGetters({
      getDiagnosisHmiButton: 'diagnosis/getDiagnosisHmiButton',
      getDiagnosisHmiPanel: 'diagnosis/getDiagnosisHmiPanel',
      getDeviceInfo: 'bikeConnect/getDeviceInfo'
    }),
    /** 用 ConsolePN 找到對應的圖片 */
    imgOfPartNo () {
      const partNo = funcOriginalPartNo(this.getDeviceInfo.ConsolePN);
      const allowPart = allowPartNo[partNo];
      // console.log("TCL: imgOfPartNo -> allowPart", allowPart)
      let photo = '';

      if (allowPart) {
        photo = allowPart.photo;
        return require(`@/assets/images/diagnosis/${photo}`);
      } else {
        photo = 'no_image.jpg';
        return require(`@/assets/images/diagnosis/${photo}`);
      }
    },
    step () {
      return Object.keys(this.btnNext);
    },
    stepName () {
      return this.btnNext[this.step[this.count]];
    },
    result () {
      const up = this.$store.state.diagnosis.diagnosisHmiButton.up;
      const down = this.$store.state.diagnosis.diagnosisHmiButton.down;
      const power = this.$store.state.diagnosis.diagnosisHmiButton.power;

      return { up, down, power };
    }
  },
  methods: {
    funcStepOne () {
      // Panel Checking
      this.keyName.up = 'Yes';
      this.keyName.down = 'No';
      this.keyName.power = this.$t('diagnosis.btnStep.cancel');

      this.isGreen = false;
      this.funcDiagnosisContent(
        this.content.step1,
        this.content.step2,
        this.content.step3
      );
      if (this.keyText === 'keySuccess') {
        // console.log('keySuccess')
        this.keyName.up = '';
        this.keyName.down = this.$t('diagnosis.btnStep.cancel');
        this.keyName.power = this.$t('diagnosis.btnStep.next');

        this.funcDiagnosisContent(
          this.content.step4,
          '',
          this.content.step7
        );

        this.description.status = this.content.step5;

        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Panel',
            result: { panel: 'passed' },
            errorCode: this.bikeErrorCode.ErrorCodeBike
          }
        );
      } else if (this.keyText === 'keyFailed') {
        this.keyName.up = '';
        this.keyName.down = this.$t('diagnosis.btnStep.cancel');
        this.keyName.power = this.btnStep;

        this.funcDiagnosisContent(
          this.content.step4,
          '',
          this.content.step7
        );

        this.description.status = this.content.step6;

        let displayEyeErrorCode = 264;
        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Panel',
            result: { panel: 'failed' },
            errorCode: displayEyeErrorCode
          }
        );
      }

      // 錯誤
      if (this.bikeVal === 1001 && this.bikeErrorCode === 30001) {
        this.funcDiagnosisContent(
          this.content.step4,
          this.content.step6,
          this.content.step7
        );

        this.description.status = this.content.step6;

        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Panel',
            result: { panel: 'failed' }
          }
        );
      }
    },
    funcStepTwo () {
      // Button Checking - UP
      this.keyName.up = '';
      this.keyName.down = '';
      this.keyName.power = '';

      this.time = true;
      this.isHidePower = true;

      this.funcDiagnosisContent(
        this.description.status,
        `${this.content.step7}\n${this.content.step8}`,
        this.content.step9
      );

      if (this.bikeVal === 'u') {
        this.time = false;
        this.funcDiagnosisContent(
          this.content.step7,
          '',
          this.content.step12
        );
        this.description.status = this.content.step10;

        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Button',
            result: { up: 'passed' },
            errorCode: this.bikeErrorCode.ErrorCodeBike
          }
        );
        setTimeout(() => {
          this.count++;
        }, 1000);
      } else if (this.bikeVal === 1001 && this.second === 0) {
        // Failed
        this.time = false;
        this.funcDiagnosisContent(
          this.content.step7,
          '',
          this.content.step12
        );

        this.description.status = this.content.step11;

        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Button',
            result: { up: 'failed' },
            errorCode: this.bikeErrorCode.ErrorCodeBike
          }
        );
        setTimeout(() => {
          this.count++;
        }, 1000);
      }
    },
    funcStepThree () {
      // Button Checking - down
      this.time = true;
      this.funcDiagnosisContent(
        this.description.status,
        `${this.content.step12}\n${this.content.step8}`,
        this.content.step14
      );
      // this.btnStep = 'Finish'

      if (this.bikeVal === 'd') {
        this.time = false;
        this.funcDiagnosisContent(
          this.content.step13,
          '',
          this.content.step17
        );

        this.description.status = this.content.step15;

        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Button',
            result: {
              up: this.getDiagnosisHmiButton.up,
              down: 'passed'
            },
            errorCode: this.bikeErrorCode.ErrorCodeBike
          }
        );
        setTimeout(() => {
          this.count++;
        }, 1000);
      } else if (this.bikeVal === 1001 && this.second === 0) {
        // Failed
        this.time = false;
        this.funcDiagnosisContent(
          this.content.step13,
          '',
          this.content.step17
        );

        this.description.status = this.content.step16;

        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Button',
            result: {
              up: this.getDiagnosisHmiButton.up,
              down: 'failed'
            },
            errorCode: this.bikeErrorCode.ErrorCodeBike
          }
        );
        setTimeout(() => {
          this.count++;
        }, 1000);
      }
    },
    funcStepFour () {
      // Button Checking - power
      this.time = true;
      this.funcDiagnosisContent(
        this.description.status,
        `${this.content.step17}\n${this.content.step8}`,
        this.content.step20
      );
      // this.btnStep = 'Finish'

      if (this.bikeVal === 'w') {
        this.time = false;
        this.funcDiagnosisContent(
          this.content.step17,
          '',
          this.content.step21
        );

        this.description.status = this.content.step18;

        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Button',
            result: {
              up: this.getDiagnosisHmiButton.up,
              down: this.getDiagnosisHmiButton.down,
              power: 'passed'
            },
            errorCode: this.bikeErrorCode.ErrorCodeBike
          }
        );
        setTimeout(() => {
          this.count++;
        }, 1000);
      } else if (this.bikeVal === 1001 && this.second === 0) {
        // Failed
        this.time = false;
        this.funcDiagnosisContent(
          this.content.step17,
          '',
          this.content.step21
        );

        this.description.status = this.content.step19;

        this.$store.dispatch(
          'diagnosis/changeDiagnosisHmi',
          {
            title: 'Button',
            result: {
              up: this.getDiagnosisHmiButton.up,
              down: this.getDiagnosisHmiButton.down,
              power: 'failed'
            },
            errorCode: this.bikeErrorCode.ErrorCodeBike
          }
        );
        setTimeout(() => {
          this.count++;
        }, 1000);
      }
    },
    funcStepFive () {
      this.keyName.up = '';
      this.keyName.down = '';
      this.keyName.power = this.content.step21; // Finish

      const obj1 = this.getDiagnosisHmiButton.status.result;
      const obj2 = this.getDiagnosisHmiPanel.status.result;
      const arr = [].concat(Object.values(obj1), Object.values(obj2));

      if (arr.includes('failed')) {
        this.isSuccess = false;
        this.isError = true;
        this.isActive = false;
      } else {
        this.isSuccess = true;
        this.isError = false;
        this.isActive = false;
      }

      this.hmiDisplayConsole = true;

      this.isActive = false;
      this.isGreen = false;
      this.isHide = true;
      this.time = false;
      this.isHidePower = false;

      this.description.desc1 = this.description.status;
      this.description.desc2 = `${this.content.step21}: `;

      // 文字
      this.description.displayConsoleText.panel = this.content.finish.panel;
      this.description.displayConsoleText.up = this.content.finish.up;
      this.description.displayConsoleText.down = this.content.finish.down;
      this.description.displayConsoleText.power = this.content.finish.power;

      // 結果
      this.description.displayConsoleText.panelResult = this.getDiagnosisHmiPanel.panel;
      this.description.displayConsoleText.upResult = this.getDiagnosisHmiButton.up;
      this.description.displayConsoleText.downResult = this.getDiagnosisHmiButton.down;
      this.description.displayConsoleText.powerResult = this.getDiagnosisHmiButton.power;

      this.description.desc3 = '';
      this.btnStep = this.content.step21;
    },
    funcStepDefault () {
      //  UI 显示
      this.hmiDisplayConsole = false;

      this.isHide = false;
      this.isHidePower = false;
      this.isGreen = true;
      this.time = false;

      this.isError = false;
      this.isSuccess = false;
      this.isActive = true;
      //  UI 显示 end
      this.funcDiagnosisContent(
        '',
        this.content.step1,
        this.content.step2
      );

      // 文字
      this.description.displayConsoleText.panel = '';
      this.description.displayConsoleText.up = '';
      this.description.displayConsoleText.down = '';
      this.description.displayConsoleText.power = '';

      // 結果
      this.description.displayConsoleText.panelResult = '';
      this.description.displayConsoleText.upResult = '';
      this.description.displayConsoleText.downResult = '';
      this.description.displayConsoleText.powerResult = '';

      this.keyName.up = '';
      this.keyName.down = this.$t('diagnosis.btnStep.cancel');
      this.keyName.power = this.$t('diagnosis.btnStep.start');

      this.keyText = '';
      this.description.status = '';
      this.second = 10;
      this.count = 0;
    },
    funcDiagnosisContent (c1, c2, c3) {
      this.description.desc1 = c1;
      this.description.desc2 = c2;
      this.description.desc3 = c3;
    },
    strSlice (str) {
      if (str !== undefined) {
        const index = str.indexOf(20);
        return str.slice(0, index);
      }
    },
    funcHandleUp (key) {
      if (this.keyName.up === 'Yes' || key === 'Yes') {
        this.$emit('keyUpEvent', this.keyName.up);
        this.keyText = 'keySuccess';
        this.count++;
      } else if (this.keyName.up === '') return;
      else this.second = 10;
      this.btnStep = this.btnName[this.count];
    },
    funcHandleDown (key) {
      if (this.keyName.down === 'No' || key === 'No') {
        this.$emit('keyDownEvent', this.keyName.down);
        this.keyText = 'keyFailed';
        this.count++;
      } else if (this.keyName.down === '') return;
      else {
        this.second = 10;
        this.$emit('keyDownEvent', key.toLowerCase());
      }
      this.btnStep = this.btnName[this.count];
    },
    funcHandlePower (power) {
      // bug: 如果click cancel是直接跳到診斷up btn？
      // if (this.count < this.step.length) {
      //   this.count++
      // }

      if (power === 'Cancel' || power === 'cancelPower') {
        this.$emit('keyPowerEvent', 'cancel');
      }
      switch (this.stepName) {
        case 'start':
          this.funcStepOne();
          this.count++;
          this.$emit('keyPowerEvent', { name: this.diagnosisName, action: this.stepName });
          break;
        case 'next':
          this.funcStepTwo();
          this.count++;
          this.$emit('keyPowerEvent', { name: this.diagnosisName, action: this.stepName });
          break;
        case 'finish':
          this.funcStepFive();
          this.$emit('keyPowerEvent', { name: this.diagnosisName, action: this.stepName });
          break;
      }

      // if (this.count < this.step.length - 1) {
      //   this.count++
      // }
      this.btnStep = this.btnName[this.count];
    },
    funcHandleSpecialHmi (obj) {
      this.$emit('specialHmi', obj);
    }
  }
};
</script>
